import { Spinner } from "reactstrap";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import ErrorMessage from "../../../../../components/comman/ErrorMessage";
import { errorTypes } from "../../../../../utility/InputValidation";

export default function EmployeeBankDetails({
  locationData,
  pageStatesMain,
  setPageStatesMain,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingBankData, setIsLoadingBankData] = useState(false)
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (locationData) {
      reset({
        accountHolderName: locationData?.userdetail?.accountHolderName || "",
        accountNumber: locationData?.userdetail?.accountNumber || "",
        ifscCode: locationData?.userdetail?.ifscCode || "",
        bankName: locationData?.userdetail?.bankName || "",
        branchName: locationData?.userdetail?.branchName || "",
        branchAddress: locationData?.userdetail?.branchAddress || "",
      });
    }
  }, []);

  const fetchBankDetails = async (ifsc) => {
    if (ifsc && ifsc.length === 11) {
      setIsLoadingBankData(true)
      try {
        const response = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
        if (response.ok) {
          const data = await response.json();
          setValue("bankName", data.BANK || "");
          setValue("branchName", data.BRANCH || "");
          setValue("branchAddress", data.ADDRESS || "");
        } else {
          toast.error("Invalid IFSC Code");
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
      } finally {
        setIsLoadingBankData(false)
      }
    } else {
      setIsLoadingBankData(false)
    }
  };

  const onSubmit = (data) => {
    // console.log("submitData>>>>>>>>>>",data);
    const formData = new FormData();
    formData.append("accountHolderName", data?.accountHolderName);
    formData.append("accountNumber", data?.accountNumber);
    formData.append("ifscCode", data?.ifscCode);
    formData.append("bankName", data?.bankName);
    formData.append("branchName", data?.branchName);
    formData.append("branchAddress", data?.branchAddress);
    formData.append("activeTab", "Bank Details");

    const options = {
      method: "POST",
      form_data: formData,
    };
    let API =
      apiUrl?.add_employee +
      `?userId=${locationData?.id ? locationData?.id : pageStatesMain?.Id_onCreateEmp
      }`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        setPageStatesMain((prev) => ({
          ...prev,
          activeTab: 6,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (

    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-12 ">
          <div className="row">
            <div className="col-12">
              <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                Bank Details
              </h4>
            </div>
            {/* //bank */}
            <div className="col-12 col-md-4">
              <div className="form-group mb-3">
                <label htmlFor="IFSC" className="form-label">
                  IFSC Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="IFSC"
                  placeholder="Enter IFSC/RTGS Code"
                  maxLength={11}
                  {...register("ifscCode", {
                    required: "This field is Required",
                    pattern: {
                      value: /^[A-Z0-9]*$/,
                      message: "It must contain only numbers and letters",
                    },
                    onChange: (e) => {
                      e.target.value = e.target.value.toUpperCase();
                      if (e.target.value.length === 11) {
                        fetchBankDetails(e.target.value);
                      } else {
                        setValue("bankName", "");
                        setValue("branchName", "");
                        setValue("branchAddress", "");
                      }
                    }
                  })}
                />
                <ErrorMessage message={errors?.ifscCode?.message} />
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group mb-3">
                <label htmlFor="bankName" className="form-label">
                  Bank Name <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    id="bankName"
                    placeholder={isLoadingBankData ? "Loading..." : "Enter Bank Name"}
                    maxLength={160}
                    {...register("bankName", {
                      ...errorTypes.required("Bank Name"),
                      ...errorTypes.name,
                    })}
                    disabled
                  />
                  {isLoadingBankData && (
                    <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
                <ErrorMessage message={errors?.bankName?.message} />
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group mb-3">
                <label htmlFor="branchName" className="form-label">
                  Branch Name <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    id="branchName"
                    placeholder={isLoadingBankData ? "Loading..." : "Enter Branch Name"}
                    maxLength={160}
                    {...register("branchName", {
                      required: "This field is Required",
                    })}
                    disabled
                  />
                  {isLoadingBankData && (
                    <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
                <ErrorMessage message={errors?.branchName?.message} />
              </div>
            </div>
            {/* ac no. */}
            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="AccNum" className="form-label">
                  Account Number <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  id="AccNum"
                  placeholder="Enter Account Number"
                  {...register("accountNumber", {
                    ...errorTypes.required("Account Number"),
                    ...errorTypes?.accountNumber
                  })}
                />
                <ErrorMessage message={errors?.accountNumber?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="AccHolder" className="form-label">
                  Account Holder Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="AccHolder"
                  maxLength={160}
                  placeholder="Enter Account Holder Name"
                  {...register("accountHolderName", {
                    ...errorTypes.required("Account Holder Name"),
                    ...errorTypes.name,
                  })}
                />
                <ErrorMessage message={errors?.accountHolderName?.message} />
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="branchAddress" className="form-label">
                  Branch Address <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <textarea
                    className="form-control"
                    id="branchAddress"
                    placeholder={isLoadingBankData ? "Loading..." : "Enter Branch Address"}
                    rows={2}
                    defaultValue={""}
                    {...register("branchAddress", {
                      required: "This field is Required",
                    })}
                    disabled
                  />
                  {isLoadingBankData && (
                    <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
                <ErrorMessage message={errors?.branchAddress?.message} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <button className="btn btn-primary px-4" type="submit">
          {isLoading ? <Spinner /> : "Save and Continue"}
        </button>
      </div>
    </form>

  );
}
